import { FaClock, FaChartBar, FaMoneyBillWave, FaMoneyCheckAlt, FaPlus, FaTags, FaBook } from 'react-icons/fa';

export const EXPENSE_APPROVALS_PATH = '/expenses/approvals';

export const getExpenseSidebarSubItems = () => [
    { label: 'Add Expense', to: '/expenses/new', Icon: FaPlus, permissionKey: 'expenses.create' },
    { label: 'Expense Management', to: '/expenses', Icon: FaMoneyBillWave, permissionKey: 'expenses.view' },
    { label: 'Expense Approvals', to: EXPENSE_APPROVALS_PATH, Icon: FaClock, permissionKey: 'expenses.approve' },
    { label: 'Reports & Analytics', to: '/expenses/reports', Icon: FaChartBar, permissionKey: 'expenses.reports.view' },
    { label: 'Category Analytics', to: '/expenses/analytics', Icon: FaChartBar, permissionKey: 'expenses.analytics.view' },
    { label: 'Budget Management', to: '/expenses/budgets', Icon: FaMoneyCheckAlt, permissionKey: 'expenses.budgets.manage' },
    { label: 'GL Posting', to: '/expenses/gl-posting', Icon: FaBook, permissionKey: 'expenses.gl_post' },
    {
        label: 'Setup',
        subItems: [
            { label: 'Categories', to: '/expenses/categories', Icon: FaTags, permissionKey: 'expenses.categories.manage' },
            { label: 'Subcategories', to: '/expenses/subcategories', Icon: FaTags, permissionKey: 'expenses.subcategories.manage' },
        ]
    },
];
